export default defineNuxtRouteMiddleware((to) => {
  if (!isClient)
    return

  const { setLastPageBeforeCheckout } = useGeneralTracking()
  setLastPageBeforeCheckout(to)
})
